module.exports = __webpack_public_path__ + "img/产品优势_安全性和合规性.0518e246.png";